import { render } from "./B2CStats.vue?vue&type=template&id=f665735c&lang=pug"
import script from "./B2CStats.vue?vue&type=script&setup=true&lang=js"
export * from "./B2CStats.vue?vue&type=script&setup=true&lang=js"

import "./B2CStats.vue?vue&type=style&index=0&id=f665735c&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__